import { Link } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

export const EventAudienceLink: React.FC<{
  to: string;
}> = (props) => {
  return (
    <Link as={NextLink} href={props.to}>
      {props.children}
    </Link>
  );
};
